import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';
import { Form, Input, InputNumber, Switch, Select, message } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'name', label: 'Name', placeholder: 'e.g. Pro Plan', required: true },
  { key: 'description', label: 'Description', placeholder: 'Plan description', textarea: true, rows: 3 },
  // The paywall's benefit tiles, "value|label" each; translated like the name.
  { key: 'features', label: 'Features', placeholder: 'Type a feature and press Enter', tags: true },
];

export const SubscriptionPlanCreate: React.FC = () => {
  const { formProps, onFinish } = useForm({ resource: 'subscription-plans' });
  const { push } = useNavigation();

  const handleSubmit = async (values: any) => {
    try {
      await onFinish({
        ...values,
        translations: normalizeTranslations(values.translations, LANG_FIELDS),
      });
      message.success('Subscription plan created');
      push('/subscription-plans');
    } catch (err: any) {
      message.error(err?.message || 'Failed to create plan');
    }
  };

  return (
    <Create resource="subscription-plans" saveButtonProps={{ onClick: () => formProps.form?.submit() }}>
      <Form {...formProps} layout="vertical" onFinish={handleSubmit}>
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Plan Type" name="planType" rules={[{ required: true }]}>
          <Select
            options={[
              { label: 'Free', value: 'FREE' },
              { label: 'Basic', value: 'BASIC' },
              { label: 'Pro', value: 'PRO' },
              { label: 'Premium', value: 'PREMIUM' },
              { label: 'Enterprise', value: 'ENTERPRISE' },
            ]}
          />
        </Form.Item>
        <Form.Item label="Monthly Price (cents)" name="priceMonthlyCents" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Yearly Price (cents)" name="priceYearlyCents">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Currency" name="currency" initialValue="HKD">
          <Input placeholder="HKD" />
        </Form.Item>
        <Form.Item label="Trial Days" name="trialDays">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Sort Order" name="sortOrder" initialValue={0}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
          <Switch />
        </Form.Item>
        <Form.Item label="Provider Product ID" name="providerProductId">
          <Input placeholder="Stripe product ID" />
        </Form.Item>
        <Form.Item label="Provider Price ID" name="providerPriceId">
          <Input placeholder="Stripe price ID" />
        </Form.Item>
      </Form>
    </Create>
  );
};
